import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import DropDownInputField from "../../components/forms/DropDownInputField";
import {fromJS} from "immutable";
import FormError from "../../components/forms/FormError";

const options = fromJS([
  {value: "auto", title: "Auto (internal rules)"},
  {value: "always", title: "Always allow"},
  {value: "never", title: "Never allow"},
])

const waterOptions = fromJS([
  {value: "auto", title: "Auto (internal rules)"},
  {value: "always", title: "Always allow"},
  {value: "once", title: "Allow only once"},
  {value: "never", title: "Never allow"},
])

class CartPoliciesForm extends Component {

  render() {
    let {errors, handleSubmit, submit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Subscriptions"
              name="subscriptionsPolicy"
              component={DropDownInputField}
              data={options}
              showBlank={false}
              valueKey="value"  
              titleKey="title" 
              serverError={this.props.errors.subscriptionsPolicy}
              />
            <Field 
              label="Water"
              name="waterOrdersPolicy"
              component={DropDownInputField}
              data={waterOptions}
              showBlank={false}
              valueKey="value"  
              titleKey="title" 
              serverError={this.props.errors.waterOrdersPolicy}
              />
            <Field 
              label="Products"
              name="productOrdersPolicy"
              component={DropDownInputField}
              data={options}
              showBlank={false}
              valueKey="value"  
              titleKey="title" 
              serverError={this.props.errors.productOrdersPolicy}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "CartPoliciesForm"
})(CartPoliciesForm);

export default ReduxForm;